

export default (props) => {

    return (<label
        htmlFor={props.id || props.name}
        className={`input input-${props.inputType} ${props.error && props.displayError ? 'error' : ''} ${props.disabled ? 'disabled' : ''} ${props.readonly ? 'readonly' : ''} ${props.success ? 'success' : ''} ${props.className || ''}`}
        style={props.style}>
        <span className="label">
            {props.label}
        </span>
        <span id={`${props.id || props.name}_help`} className="helpertext">
            {props.helpertext}
        </span>
        {props.children}
        {props.displayError && props.error ?
            <p id={`${props.id || props.name}_error`} className="message">
                <span
                    className="icon xsmall"
                    style={{
                        WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                        maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                        color: "currentColor"
                    }}>
                </span>
                {props.error}
            </p>
            :
            <p id={`${props.id || props.name}_message`} className="message">
                {props.message}
            </p>
        }
    </label>)
}

    
